module.exports = __webpack_public_path__ + "img/gh-12132____-102.prt.b089a1fe.jpg";